import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { useModal } from "@/hooks";
import styles from "@/styles/Modal.module.scss";
import Image from "next/legacy/image";
export default function CvvModal() {
  const { hideModal } = useModal();
  return (
    <div className={styles.cvv}>
      <h4 className={styles.title}>セキュリティコードとは</h4>
      <div className={styles.image}>
        <Image src={"/images/cvv_card.png"} width={240} height={150} />
      </div>
      <br />
      <span className={styles.description}>
        セキュリティコードとは、クレジットカードの裏面に記載された末尾3桁もしくは4桁の数字です。
      </span>
      <div className={`${styles.btnArea} ${styles.multiple} ${styles.button}`}>
        <ButtonMultiClick borderGray fontFixed large onClick={hideModal}>
          閉じる
        </ButtonMultiClick>
      </div>
    </div>
  );
}
